import { getFailedRecordsFile, getOriginalFile, getTemplateFile } from '../../api/services/BatchUploadFiles';

export const getDownloadFile = async (
  fileToDownload: string,
  fileType: 'rider' | 'location' | 'school',
  fileId?: number,
  fileName?: string
): Promise<void> => {
  switch (fileToDownload) {
    case 'originalFile':
      if (fileId) {
        const originalFileResponse = await getOriginalFile(fileId, fileType);

        if (originalFileResponse?.type === 'success') {
          await triggerDownload(originalFileResponse, fileName);
        }
      }
      break;
    case 'failedRecordsFile':
      if (fileId) {
        const failedRecordsFileResponse = await getFailedRecordsFile(fileId, fileType);

        if (failedRecordsFileResponse?.type === 'success') {
          await triggerDownload(failedRecordsFileResponse, fileName);
        }
      }
      break;
    case 'template':
      const response = await getTemplateFile({ batchUploadFileType: fileType });

      if (response?.type === 'success') {
        await triggerDownload(response, `${fileType}_upload_template.csv`);
      }
      break;
    default:
      null;
  }
};

const triggerDownload = async (response, fileName) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
